import { getCurrentLocale } from "../i18n/locale";

function pathExtention(path) {
    const currentPath = window.location.pathname;
    path = path.startsWith('/') ? path.slice(1) : path; // Ensure path does not start with '/'
    return currentPath.endsWith('/') ? currentPath + path : currentPath + '/' + path;
}

function pathUpdateWithExtention(path) {
    const currentPath = window.location.pathname;
    path = path.startsWith('/') ? path.slice(1) : path;

    return currentPath.endsWith('/') ? currentPath.split('/').slice(0, -2).join('/') + '/' + path : currentPath.split('/').slice(0, -1).join('/') + '/' + path;
}

function firstLatterCap(params = '') {
    params = params.toLowerCase();
    return params.charAt(0).toUpperCase() + params.slice(1);
}

const formatFullDate = (dateInput) => {
    if (!dateInput) return "N/A";

    const date = new Date(dateInput);

    // Options for 24-hour format with seconds
    return new Intl.DateTimeFormat(getCurrentLocale(), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true // Set to true if you want AM/PM
    }).format(date).replace(',', '');
};

export {
    pathExtention, pathUpdateWithExtention, firstLatterCap, formatFullDate
}
